'use client';

import { useParams, usePathname } from 'next/navigation';
import Script from 'next/script';
import React, { FC, useEffect, useState } from 'react';

let alreadyRunning = false;
const tokens = {
  sales: '8JCtn6hSkfqmsMSryq2i796m',
  VB: 'cRKXpwbsGoDbXhbsox37CcuK',
};

const Hoory: FC = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const pathname = usePathname();
  const params = useParams();

  useEffect(() => {
    if (scriptLoaded) {
      const badalyanPage = `/${params.lang}/badalyans-ai`;
      if (alreadyRunning) {
        if (
          (window.hoorySettings.launcherTitle === "Vigen Badalyan's AI" &&
            pathname !== badalyanPage) ||
          (window.hoorySettings.launcherTitle !== "Vigen Badalyan's AI" &&
            pathname === badalyanPage)
        ) {
          window.hoorySettings.launcherTitle =
            pathname === badalyanPage ? "Vigen Badalyan's AI" : 'Chat with sales';
          window.hoorySDK.reRun({
            websiteToken: pathname === badalyanPage ? tokens.VB : tokens.sales,
            baseUrl: 'https://app.hoory.com',
          });
        }
      } else {
        if (window.hoorySettings) {
          window.hoorySettings.type = 'expanded_bubble';
          window.hoorySettings.launcherTitle =
            pathname === badalyanPage ? "Vigen Badalyan's AI" : 'Chat with sales';
        }
        window.hoorySDK.run({
          websiteToken: pathname === badalyanPage ? tokens.VB : tokens.sales,
          baseUrl: 'https://app.hoory.com',
        });
        alreadyRunning = true;
      }
    }
  }, [pathname, scriptLoaded]);

  return (
    <Script
      strategy="afterInteractive"
      src="https://app.hoory.com/packs/js/sdk.js"
      onLoad={() => {
        window.hoorySettings = {
          position: 'right',
          type: 'standard',
          launcherTitle: 'aaa',
        };
        setScriptLoaded(true);
      }}
    />
  );
};

export default Hoory;
